$(document).ready(function () {
    window.initMyreviewsSwiper();
});

// Inicializuje Swiper pro každý dosud neinicializovaný .myreviews-swiper na stránce.
// Navigation buttons hledá uvnitř nejbližšího .myreviews wrapperu — díky tomu funguje
// správně i když je na stránce víc instancí (HP + později naloadovaná kopie v detailu).
// Vystavena přes window.* aby byla dostupná z jiných souborů — esbuild jinak izoluje scope.
window.initMyreviewsSwiper = function () {
    $(".myreviews-swiper").not(".swiper-initialized").each(function () {
        const el = this;
        const wrapper = el.closest(".myreviews") || el.parentNode;

        // Pagination element není v HTML — vytvoříme ho dynamicky a vložíme pod swiper
        // (do .myreviews__inner, mimo .myreviews__container, aby absolutně poziciované
        // šipky zůstaly vertikálně zarovnané s textem a neposunula je výška pagination).
        const pagination = document.createElement("div");
        pagination.className = "swiper-pagination myreviews__pagination";
        (wrapper.querySelector(".myreviews__inner") || wrapper).appendChild(pagination);

        new Swiper(el, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            autoHeight: true,
            autoplay: {
                delay: 4500,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
            },
            speed: 500,
            navigation: {
                nextEl: wrapper.querySelector(".myreviews__btn--next"),
                prevEl: wrapper.querySelector(".myreviews__btn--prev"),
                disabledClass: "swiper-button-disabled",
            },
            pagination: {
                el: pagination,
                clickable: true,
            },
            keyboard: {
                enabled: true,
            },
        });
    });
};
